import './utils/debug';
import './utils/native-polyfill';
import './utils/svgGetBBoxPolyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'redux/store';
import CoreRouter from 'core/Router';
import { processEnv } from './utils/config';
import { LoadingMask } from './utils/ui';
import bbtNative from '@bbtfe/native';
import bbtTracking from '@bbtfe/tracking';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { base64encode, base64decode } from './utils/base64';
import { lazyMonitor,lazyBrowserClient } from './utils/lazylib';
import { createApmBeforeSend } from './utils/apmIgnoreErrors';
import {} from './utils/index';
import {} from './utils/navigation';
import {} from './utils/request';
import {} from './utils/lazyload';
import {} from './components/Header';
import './styles/index.scss';
dayjs.extend(duration);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
window.bbtNative = bbtNative;
window.bbtTracking = bbtTracking;
window.base64encode = base64encode;
window.base64decode = base64decode;

bbtNative.ready(() => {
  store.dispatch({ type: 'UESR_REPLACE', payload: bbtNative.userinfo });
});

ReactDOM.render(
    <Provider store={store}>
      <CoreRouter />
    </Provider>,
    document.getElementById('app'),
    () => {
      LoadingMask.close();

      const env = {
        'local':'dev',
        'test':'test',
        'online':"production"
      }[processEnv.hostEnv];
      if (['production'].includes(env)) {
        bbtNative.ready(() => {
          const { loginString } = bbtNative.userinfo || {};
          if(window.apmPlus) {
            // 配置参数
            window.apmPlus('init', {
              aid: 355133,  //宝宝树服务id， 所有项目都写355133
              env,     //环境，默认'production’
              release: 'h5_fe_article_0.0.7', //业务版本
              userId: bbtNative.isApp() ? loginString : '',    //宝宝树token
              plugins: {
                blankScreen: {
                  rootSelector:'#app',
                  threshold: 1.5, // 得分阈值，小于阈值则判断为白屏
                  screenshot: true, // 是否在判断为白屏的时候截屏上报
                }
              }
            })
            // 预加载页 + 无价值 JS_ERROR 过滤，见 utils/apmIgnoreErrors.js
            window.apmPlus('on', 'beforeSend', createApmBeforeSend('/h5_fe_article/html/'))
            // 开启上报
            window.apmPlus('start');
            // 上报首屏时间到火山
            lazyMonitor().then(bbtMonitor => {
              bbtMonitor?.sendFirstScreenTimeEvent(window.apmPlus);
            });
          }
        });
      }
    }
);